import storage from './localStorage';

// init

if (storage.getItem('feedbackedArticleIds') === null) {
    storage.setItem('feedbackedArticleIds', JSON.stringify([]));
}

const getFeedbackedArticleIds = () => JSON.parse(storage.getItem('feedbackedArticleIds'));

const getFeedbackByArticleId = (id) => {
    const feedback = getFeedbackedArticleIds().filter((f) => f.id === id);

    return feedback ? feedback[0] : null;
};

const hasFeedbackedArticleId = (id) =>
    getFeedbackedArticleIds()
        .map((f) => f.id)
        .indexOf(id) > -1;

const addFeedbackedArticleId = (id, rating) => {
    let feedbackedIds = getFeedbackedArticleIds();

    storage.setItem(
        'feedbackedArticleIds',
        JSON.stringify([
            ...feedbackedIds,
            {
                id,
                rating,
            },
        ])
    );
};

export { getFeedbackedArticleIds, getFeedbackByArticleId, addFeedbackedArticleId, hasFeedbackedArticleId };
